import { defineStore } from 'pinia'

export const useShowTaskStore = defineStore('showTask', {
  state: () => {
    return { showTask: false }
  },
  actions: {
    changeShowTask(show) {
      this.showTask = show
    }
  },
  persist: {
    enabled: true // 开启数据缓存
  }
})
